import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { QuestionLabel } from './CheckboxGroup';
import { ErrorText } from '../Checkbox';
import styled from 'styled-components';

const Grid = styled.div`
  display: table;
`;

const Cell = styled.div`
  display: table-cell;
`;

const Wrap = styled.div`
  padding: 0 0 0 1rem;
`;

const renderSection = ({ meta, label, input }) => {
  const { error, touched } = meta;
  const { name, ...rest } = input;
  return (
    <div>
      <Grid>
        <Cell>
          <input name={name} id={name} type="checkbox" {...rest} />
        </Cell>
        <Cell>
          <Wrap>
            <QuestionLabel htmlFor={name}>{label}</QuestionLabel>
          </Wrap>
        </Cell>
      </Grid>
      <div>{!!error && !!touched && <ErrorText>{error}</ErrorText>}</div>
    </div>
  );
};

renderSection.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object
};

const TickBox = ({ name, label, validate }) => {
  return (
    <Field
      type="checkbox"
      name={name}
      label={label}
      validate={validate}
      component={renderSection}
    />
  );
};

export default TickBox;

TickBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  validate: PropTypes.func
};
